import { useContext } from 'react';

import { CurrencyContext } from 'utils/contexts';
import currencies from './currencySymbols';

export const useFormatPrice = (currency) => {
  const contextCurrency = useContext(CurrencyContext);

  const formatPrice = (price, currencyCode = currency || contextCurrency) => {
    // If a currency is not defined on the hook call, fallback to the context
    const symbol = currencies[currencyCode];
    const parsedPrice = parseFloat(price);

    const formattedPrice = parsedPrice.toLocaleString('en-US', {
      minimumFractionDigits: 2,
    });

    return `${symbol}${formattedPrice} ${currencyCode}`;
  };

  return formatPrice;
};
